import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import PaymentConfigurationCard from '../../components/configuraciones/PaymentConfigurationCard';
import WebhookConfigurationCard from '../../components/configuraciones/WebhookConfigurationCard';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: '20px',
  },
  title: {
    marginBottom: '30px',
  },
}));

const Configuraciones = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography component="h1" variant="h5" className={classes.title}>
        Configuraciones
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <PaymentConfigurationCard />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <WebhookConfigurationCard />
        </Grid>
      </Grid>
    </div>
  );
};

export default Configuraciones; 